import React from 'react';
import { GetStaticProps, NextPage } from 'next';
import PageLayout, { MenuProps } from '../../layouts/Page';
import AllBudgetsPageComponent from '../../components/elements/AllBudgetsPage';
import FormResponsesPage from '../../components/elements/FormResponsesPage';
import { Input } from '../../components/ui/Input';
import Button from '../../components/ui/Button';
import { LoadingIcon } from '../../components/ui/LoadingIcon';
import { initializeApollo } from '../../utils/apollo';
import { BUDGET_PAGE } from '../../queries/budgets';
import { flatten } from '../../utils/object';
import { Error, sendError } from '../../utils/error';

type Tab = 'budgets' | 'forms';

type InternalPageProps = {
  menus: MenuProps;
};

const InternalPage: NextPage<InternalPageProps> = ({ menus }) => {
  const [isLogged, setIsLogged] = React.useState(false);
  const [loadingPage, setLoadingPage] = React.useState(true);
  const [activeTab, setActiveTab] = React.useState<Tab>('budgets');
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [loginError, setLoginError] = React.useState('');

  React.useEffect(() => {
    if (localStorage.getItem('allowed-admin') === 'true') setIsLogged(true);
    setLoadingPage(false);
  }, []);

  const onSubmit = React.useCallback(() => {
    const expectedEmail = process.env.NEXT_PUBLIC_ADMIN_EMAIL;
    const expectedPassword = process.env.NEXT_PUBLIC_ADMIN_PASSWORD;
    console.log('[internal login] email typed:', email);
    console.log('[internal login] NEXT_PUBLIC_ADMIN_EMAIL:', expectedEmail);
    console.log('[internal login] email match:', email === expectedEmail);
    console.log('[internal login] password match:', password === expectedPassword);

    if (email === expectedEmail && password === expectedPassword) {
      localStorage.setItem('allowed-admin', 'true');
      setIsLogged(true);
    } else {
      setLoginError('Credenciais inválidas');
      setPassword('');
    }
  }, [email, password]);

  if (loadingPage)
    return (
      <div style={{ padding: 200 }}>
        <LoadingIcon />
      </div>
    );

  if (!isLogged)
    return (
      <PageLayout menus={menus} locale="en" isHeaderTransparent={false}>
        <form
          onSubmit={(e) => e.preventDefault()}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            alignItems: 'center',
            maxWidth: 500,
            margin: 'auto',
            padding: '100px 10px',
            textAlign: 'center',
          }}
        >
          Faça o login para continuar
          <Input placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <Input
            placeholder="Senha"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && onSubmit()}
          />
          {loginError && <p style={{ color: 'red' }}>{loginError}</p>}
          <Button onClick={onSubmit}>Entrar</Button>
        </form>
      </PageLayout>
    );

  return (
    <PageLayout menus={menus} locale="en" isHeaderTransparent>
      <div style={{ padding: '80px 24px 40px' }}>
        <nav style={{ display: 'flex', gap: 0, marginBottom: 32, borderBottom: '2px solid #eee' }}>
          {(['budgets', 'forms'] as Tab[]).map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              style={{
                padding: '10px 24px',
                background: 'none',
                border: 'none',
                borderBottom: activeTab === tab ? '2px solid #333' : '2px solid transparent',
                marginBottom: -2,
                fontWeight: activeTab === tab ? 700 : 400,
                cursor: 'pointer',
                fontSize: 15,
              }}
            >
              {tab === 'budgets' ? 'Budgets' : 'Form Responses'}
            </button>
          ))}
        </nav>

        {activeTab === 'budgets' && (
          <AllBudgetsPageComponent isLogged={isLogged} setIsLogged={setIsLogged} />
        )}
        {activeTab === 'forms' && <FormResponsesPage />}
      </div>
    </PageLayout>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  try {
    const apolloClient = initializeApollo();
    const { data } = await apolloClient.query({ query: BUDGET_PAGE });
    const newData = flatten(data);
    return {
      props: {
        menus: {
          header: newData.header,
          services: newData.services,
          footerPt: newData.footerPt,
          footerEn: newData.footerEn,
          technologies: newData.technologies,
        },
      },
    };
  } catch (error) {
    sendError({ error: error as Error, message: 'Error on internal page' });
    return { notFound: true };
  }
};

export default InternalPage;
